import CorpusWrapper from "@/pages/Corpus/Wrapper.vue";
import Root from "@/pages/Corpus/Root.vue";
import Corpus from "@/pages/Corpus/Corpus.vue";
import Sources from "@/pages/Corpus/Sources.vue";
import Chunks from "@/pages/Corpus/Chunks.vue";
import StatsRoot from "@/pages/Corpus/Stats/Root.vue";
import SpecialityChess from "@/pages/Corpus/Stats/SpecialityChess.vue";

export default [
  {
    path: "/corpus",
    component: CorpusWrapper,
    meta: { requiresAuth: true },
    children: [
      {
        name: Root.name,
        path: "",
        component: Root
      },

      {
        name: Corpus.name,
        path: ":corpusId",
        component: Corpus
      },
      {
        name: Sources.name,
        path: ":corpusId/sources",
        component: Sources
      },
      {
        name: Chunks.name,
        path: ":corpusId/chunks",
        component: Chunks
      }
    ]
  },
  {
    path: "/corpus-stats",
    component: CorpusWrapper,
    meta: { requiresAuth: true },
    children: [
      {
        name: StatsRoot.name,
        path: "",
        component: StatsRoot
      },
      {
        name: SpecialityChess.name,
        path: "speciality/:code/chess",
        component: SpecialityChess
      },
    ]
  }
];